import {MergeAccount} from "../../components/link-account/MergeAccount";
import {PageWithLayout} from "../Page";
import {CentralContent} from "../../components/central-content/CentralContent";

export const MergeAccountPage = () => {
  return (
      <PageWithLayout>
        <CentralContent>
          <MergeAccount/>
        </CentralContent>
      </PageWithLayout>
  );
};